// extracted by mini-css-extract-plugin
export default {"outerContainer":"Wrapper_outerContainer__NJCbn"};